var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('fc-icon',{staticClass:"icon",attrs:{"type":"16_back_to_top"}}),_c('span',{staticClass:"text"},[_vm._v("回到顶部")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }